import React, { lazy, Suspense, useEffect, useState } from "react";
import "@fontsource/poppins";
import './App.css';
import Navbar from './components/Navbar';
import axios from "axios";
import jsonData from "./components/ai-branding.json";
import appversion from '../package.json';
import CacheBuster from 'react-cache-buster';
import { CookieSetting } from "cookiesetting-component";

const Article = lazy(() => import("./components/Article"));
const Body = lazy(() => import("./components/Body"));
const Contact = lazy(() => import("./components/Contact"));
const Footer = lazy(() => import("./components/Footer"));


function App() {

  const appVersion = appversion.version;
  // console.log(appVersion);

  const [links, setLinks] = useState(null); // Set initial state as null

  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const timestamp = Date.now(); // Generate a unique timestamp
        const url = `${process.env.REACT_APP_ANGELAI_JSON}?timestamp=${timestamp}`;
        const response = await axios.get(url);
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);

  useEffect(() => {
    if (!links) {
      setLinks(jsonData); // Set local JSON data as fallback initially
    }
  }, []);

  return (
    <>
      <CacheBuster
        currentVersion={appversion.version}
        isEnabled={true} //If false, the library is disabled.
        isVerboseMode={false} //If true, the library writes verbose logs to console.
        // loadingComponent={<Loading />} //If not pass, nothing appears at the time of new version check.
        //If public assets are hosted somewhere other than root on your server.
        metaFileDirectory={process.env.PUBLIC_URL}
      >
        {links ? (
          <>
            <Suspense fallback={<div />}>
              <Navbar />
            </Suspense>
            <Suspense fallback={<div />}>
              <Article />
            </Suspense>
            <Suspense fallback={<div />}>
              <Contact />
            </Suspense>
            <Suspense fallback={<div />}>
              <Body links={links} />
            </Suspense>
            <Suspense fallback={<div />}>
              <Footer />
            </Suspense>
          </>
        ) : (
          <div>Loading...</div>
        )}
      </CacheBuster>
      <CookieSetting 
        privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
        configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
        analytics={process.env.REACT_APP_ANALYTICS_PATH}
      />
    </>
  );
}

export default App;
